import React from 'react'
import { useKeenSlider } from 'keen-slider/react'
import 'keen-slider/keen-slider.min.css'

const SLIDES_DEFAULT = [
   'Full Stack Developer Job',
   'Java Developer Job',
   'Python Developer Job',
   'Software Engineer Job',
]

export const SLIDES_ENGLISH_V2 = [
   'Full Stack Developer Job',
   'Software Engineer Job',
]
export const SLIDES_ENGLISH_V3 = [
   'Full Stack Developer',
   'Python Developer',
   'Java Developer',
   'Software Engineer',
]

export default function Animate({ slides, className = '' }) {
   const slideLabels = slides ?? SLIDES_DEFAULT
   const [sliderRef] = useKeenSlider(
      {
         loop: true,
         slides: {
            origin: 'center',
            perView: 1
         },
         vertical: true
      },
      [
         slider => {
            let timeout
            let mouseOver = false
            function clearNextTimeout() {
               clearTimeout(timeout)
            }
            function nextTimeout() {
               clearTimeout(timeout)
               if (mouseOver) return
               timeout = setTimeout(() => {
                  slider.next()
               }, 1000)
            }
            slider.on('created', () => {
               nextTimeout()
            })
            slider.on('dragStarted', clearNextTimeout)
            slider.on('animationEnded', nextTimeout)
            slider.on('updated', nextTimeout)
         }
      ]
   )

   const sliderClassName = ['keen-slider', 'programs_animate', className]
      .filter(Boolean)
      .join(' ')

   return (
      <span ref={sliderRef} className={sliderClassName}>
         {slideLabels.map((label) => (
            <span key={label} className='keen-slider__slide'>
               {label}
            </span>
         ))}
      </span>
   )
}
